import React from 'react';
import { GetInTouchCard, GetInTouchSection } from '../styled/GetInTouch.styled';

const GetInTouch = () => {
    return (
        <GetInTouchSection>
          
            <h4>Get In Touch</h4>
            <GetInTouchCard>
                <h4>Send A Message</h4>
                <input type="text" placeholder='Ahnab Shahin' />
                <input type="email" placeholder='example@gmail.com' />
                <textarea type="text" placeholder='Massage' />
                <button> Send </button>
            </GetInTouchCard>
        </GetInTouchSection>
    );
};

export default GetInTouch;